// import React, { useEffect, useState, useRef } from 'react';
// import Product from './Product';
// import Popular from './Popular';
// import DealsOfTheDay from './DealsOfTheDay.jsx';
// import Recommended from './Recommended.jsx';
// import Slider from "react-slick";
// import axios from 'axios';
// import { useWishlist } from "../../contexts/WishlistContext";

// function ParentComponent({
//   refRestCart,
//   uid,
//   advertisements,
//   loadingAds,
//   adError,
//   adSettings,
//   selectedBrands = []
// }) {
//   const [categoriesWithCounts, setCategoriesWithCounts] = useState([]);
//   const { products, setProducts } = useWishlist();
//   const [loading, setLoading] = useState(false);

//   // ✅ totalItems is ONLY ever set from product-all/ API (no category_id)
//   // It always represents the full "All Products" count, never a category count
//   const [totalItems, setTotalItems] = useState(0);

//   const buildBrandParams = () =>
//     selectedBrands && selectedBrands.length > 0
//       ? selectedBrands.map(b => `brand=${encodeURIComponent(b)}`).join('&')
//       : '';

//   const getCategoriesWithCounts = async (allTotal) => {
//     try {
//       const brandParams = buildBrandParams();
//       const url = `https://backend.frozenwala.com/api/auth/categories/${brandParams ? `?${brandParams}` : ''}`;
//       const response = await axios.get(url);

//       // Patch: categories API has no "All Products" entry and its total_items are per-category.
//       // We set total_items on each category from the API as-is (for their own tab badge).
//       // "All Products" count comes from totalItems state (product-all/ API), not here.
//       setCategoriesWithCounts(response.data);
//       return response.data;
//     } catch (error) {
//       console.error("Error fetching categories with counts:", error);
//       return [];
//     }
//   };

//   const getProducts = async (categoryId, categoryName = null) => {
//     try {
//       setLoading(true);

//       const isAllProducts = !categoryId || categoryId === 'all' || categoryId === '';
//       const brandParams = buildBrandParams();

//       let categoryUrl = isAllProducts
//         ? `https://backend.frozenwala.com/api/auth/category/product-all/?category_id=`
//         : `https://backend.frozenwala.com/api/auth/category/product-all/?category_id=${categoryId}`;
//       if (brandParams) categoryUrl += `&${brandParams}`;

//       const allProductsUrl = `https://backend.frozenwala.com/api/auth/product-all/${brandParams ? `?${brandParams}` : ''}`;

//       // Fire both simultaneously
//       const [categoryRes, allProductsRes] = await Promise.all([
//         axios.get(categoryUrl),
//         axios.get(allProductsUrl),
//       ]);

//       const catData = categoryRes.data;
//       const productList = catData?.products ?? (Array.isArray(catData) ? catData : []);

//       const allData = allProductsRes.data;
//       const allTotal = allData?.total_items ?? 0;

//       setProducts(productList);

//       setTotalItems(allTotal);

//     } catch (error) {
//       console.error("Error fetching products:", error);
//       setProducts([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const getAllProducts = async () => {
//     try {
//       setLoading(true);
//       const brandParams = buildBrandParams();
//       const url = `https://backend.frozenwala.com/api/auth/product-all/${brandParams ? `?${brandParams}` : ''}`;

//       const response = await axios.get(url);
//       const data = response.data;
//       const productList = data?.products ?? (Array.isArray(data) ? data : []);
//       const count = data?.total_items ?? productList.length;

//       setProducts(productList);

//       // ✅ totalItems set from product-all/ API
//       setTotalItems(count);

//       await getCategoriesWithCounts(count);

//     } catch (error) {
//       console.error("Error fetching all products:", error);
//       setProducts([]);
//       setTotalItems(0);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     getAllProducts();
//   }, [selectedBrands]);

//   return (
//     <div>
//       {loading && <div className="loading-overlay"></div>}

//       <Recommended
//         refreshCart={refRestCart}
//         uid={uid}
//         selectedBrands={selectedBrands}
//       />

//       <DealsOfTheDay
//         refreshCart={refRestCart}
//         uid={uid}
//         selectedBrands={selectedBrands}
//       />

//       <Popular
//         refreshCart={refRestCart}
//         uid={uid}
//         selectedBrands={selectedBrands}
//       />

//       {advertisements.length > 0 && (
//         <div style={{ background: "#fff" }}>
//           <div className="container">
//             <div className="row justify-content-center">
//               <div className="col-12 col-lg-10 col-xl-8" style={{ width: "100%" }}>
//                 {loadingAds ? (
//                   <div className="text-center py-3">
//                     <div className="spinner-border spinner-border-sm text-secondary" role="status">
//                       <span className="visually-hidden">Loading ads...</span>
//                     </div>
//                   </div>
//                 ) : adError ? (
//                   <div className="alert alert-warning text-center" role="alert">
//                     {adError}
//                   </div>
//                 ) : (
//                   <div className="advertisement-slider-container" style={{ width: "100%" }}>
//                     <Slider {...adSettings}>
//                       {advertisements.map((ad) => (
//                         <div key={ad.id} className="px-2" style={{ width: "100%" }}>
//                           <div className="ad-slide" style={{ width: "100%" }}>
//                             <img
//                               src={ad.image}
//                               alt={ad.title || "Advertisement"}
//                               className="img-fluid rounded"
//                               style={{
//                                 height: "300px",
//                                 objectFit: "cover",
//                                 width: "100%",
//                                 borderRadius: "10px",
//                                 boxShadow: "0 4px 12px rgba(0,0,0,0.1)"
//                               }}
//                               onError={(e) => {
//                                 e.target.onerror = null;
//                                 e.target.src = "/img/gallery/default-ad.jpg";
//                               }}
//                             />
//                           </div>
//                         </div>
//                       ))}
//                     </Slider>
//                   </div>
//                 )}
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//       <Product
//         refreshCart={refRestCart}
//         getProducts={getProducts}
//         getAllProducts={getAllProducts}
//         products={products}
//         categoriesWithCounts={categoriesWithCounts}
//         selectedBrands={selectedBrands}
//         loading={loading}
//         totalItems={totalItems}
//       />
//     </div>
//   );
// }

// export default ParentComponent;


// import React, { useEffect, useState, useRef } from 'react';
// import Product from './Product';
// import Popular from './Popular';
// import DealsOfTheDay from './DealsOfTheDay.jsx';
// import Recommended from './Recommended.jsx';
// import Slider from "react-slick";
// import axios from 'axios';
// import { useWishlist } from "../../contexts/WishlistContext";

// function ParentComponent({
//   refRestCart,
//   uid,
//   advertisements,
//   loadingAds,
//   adError,
//   adSettings,
//   selectedBrands = []
// }) {
//   const [categoriesWithCounts, setCategoriesWithCounts] = useState([]);
//   const { products, setProducts } = useWishlist();
//   const [loading, setLoading] = useState(false);
//   const [totalItems, setTotalItems] = useState(0);
  
//   const isBrandChangeReset = useRef(false);

//   const buildBrandParams = () =>
//     selectedBrands && selectedBrands.length > 0
//       ? `brand=${selectedBrands.map(b => encodeURIComponent(b)).join(',')}`
//       : '';

//   const getCategoriesWithCounts = async () => {
//     try {
//       const brandParams = buildBrandParams();
//       let url = `https://backend.frozenwala.com/api/auth/categories/`;
//       if (brandParams) url += `?${brandParams}`;
//       const response = await axios.get(url);
//       setCategoriesWithCounts(response.data);
//       return response.data;
//     } catch (error) {
//       console.error("Error fetching categories with counts:", error);
//       return [];
//     }
//   };

//   const getProducts = async (categoryId) => {
//     try {
//       setLoading(true);
//       const brandParams = buildBrandParams();
//       let url;
//       if (!categoryId || categoryId === 'all') {
//         url = `https://backend.frozenwala.com/api/auth/product-all/`;
//       } else {
//         url = `https://backend.frozenwala.com/api/auth/category/product-all/?category_id=${categoryId}`;
//       }
//       if (brandParams) url += `${url.includes('?') ? '&' : '?'}${brandParams}`;
//       const response = await axios.get(url);
//       const data = response.data;
//       const productList = data?.products ?? (Array.isArray(data) ? data : []);
//       setProducts(productList);
//       if (!categoryId || categoryId === 'all') setTotalItems(data?.total_items ?? productList.length);
//     } catch (error) {
//       console.error("Error fetching products:", error);
//       setProducts([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const getAllProducts = async () => {
//     try {
//       setLoading(true);
//       const brandParams = buildBrandParams();
//       let url = `https://backend.frozenwala.com/api/auth/product-all/`;
//       if (brandParams) url += `?${brandParams}`;
//       const response = await axios.get(url);
//       const data = response.data;
//       const productList = data?.products ?? (Array.isArray(data) ? data : []);
//       setProducts(productList);
//       setTotalItems(data?.total_items ?? productList.length);
//       await updateCategoryCountsFromProducts(productList);
//     } catch (error) {
//       console.error("Error fetching all products:", error);
//       setProducts([]);
//       setTotalItems(0);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const updateCategoryCountsFromProducts = async (productList) => {
//     try {
//       const categoriesResponse = await axios.get(`https://backend.frozenwala.com/api/auth/categories/`);
//       const allCategories = categoriesResponse.data;
//       const categoryCountMap = new Map();
//       productList.forEach(product => {
//         const catId = product.category_id || product.category;
//         if (catId) categoryCountMap.set(catId, (categoryCountMap.get(catId) || 0) + 1);
//       });
//       const updatedCategories = allCategories.map(category => ({
//         ...category,
//         total_items: categoryCountMap.get(category.id) || 0
//       }));
//       setCategoriesWithCounts(updatedCategories);
//     } catch (error) {
//       console.error("Error updating category counts:", error);
//       await getCategoriesWithCounts();
//     }
//   };

//   useEffect(() => {
//     isBrandChangeReset.current = true;
//     getAllProducts();
//     setTimeout(() => { isBrandChangeReset.current = false; }, 100);
//   }, [selectedBrands]);

//   const handleCategoryChange = (categoryId) => {
//     if (isBrandChangeReset.current) return;
//     if (categoryId === 'all') getAllProducts();
//     else getProducts(categoryId);
//   };

//   return (
//     <div>
//       {loading && <div className="loading-overlay"></div>}

//       {/* 1. Recommended for You Section */}
//       <div className="mb-4">
//         <Recommended
//           refreshCart={refRestCart}
//           uid={uid}
//           selectedBrands={selectedBrands}
//         />
//       </div>

//       {/* 2. Side-by-Side Area: Shrunk horizontally to align with slider layout bounds */}
//       <div 
//         style={{ 
//           margin: "0 auto", 
//           maxWidth: "1280px", 
//           paddingLeft: "15px", 
//           paddingRight: "15px" 
//         }} 
//         className="mb-5"
//       >
//         <div className="row g-4 justify-content-center align-items-stretch">
//           {/* Left Block: Deals of the Day */}
//           <div className="col-12 col-md-6 d-flex flex-column">
//             <DealsOfTheDay
//               refreshCart={refRestCart}
//               uid={uid}
//               selectedBrands={selectedBrands}
//             />
//           </div>

//           {/* Right Block: Popular Rows */}
//           <div className="col-12 col-md-6 d-flex flex-column">
//             <Popular
//               refreshCart={refRestCart}
//               uid={uid}
//               selectedBrands={selectedBrands}
//             />
//           </div>
//         </div>
//       </div>

// {/* Advertisements Slider Section */}
//       {advertisements.length > 0 && (
//         <div 
//           style={{ 
//             margin: "0 auto", 
//             maxWidth: "1280px", 
//             paddingLeft: "15px", 
//             paddingRight: "15px" 
//           }} 
//           className="my-3 py-1"
//         >
//           <div className="row justify-content-center g-0">
//             <div className="col-12" style={{ width: "100%" }}>
//               <div className="advertisement-slider-container" style={{ width: "100%" }}>
//                 <style>{`
//                   .advertisement-slider-container .slick-slide > div {
//                     display: flex !important;
//                     justify-content: center !important;
//                   }
//                   @media (max-width: 575.98px) {
//                     .ad-responsive-img {
//                       height: clamp(140px, 25vh, 220px) !important;
//                     }
//                   }
//                 `}</style>
//                 <Slider {...adSettings}>
//                   {advertisements.map((ad) => (
//                     <div key={ad.id} className="px-0" style={{ width: "100%" }}>
//                       <div className="ad-slide" style={{ width: "100%" }}>
//                         <img
//                           src={ad.image}
//                           alt={ad.title || "Advertisement"}
//                           className="img-fluid rounded ad-responsive-img"
//                           style={{
//                             height: "300px",
//                             objectFit: "cover",
//                             width: "100%",
//                             borderRadius: "10px",
//                             boxShadow: "0 4px 12px rgba(0,0,0,0.1)"
//                           }}
//                           onError={(e) => {
//                             e.target.onerror = null;
//                             e.target.src = "/img/gallery/default-ad.jpg";
//                           }}
//                         />
//                       </div>
//                     </div>
//                   ))}
//                 </Slider>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* 3. Main Product Catalog Grid Component */}
//       <Product
//         refreshCart={refRestCart}
//         getProducts={handleCategoryChange}
//         getAllProducts={getAllProducts}
//         products={products}
//         categoriesWithCounts={categoriesWithCounts}
//         selectedBrands={selectedBrands}
//         loading={loading}
//         totalItems={totalItems}
//       />
//     </div>
//   );
// }

// export default ParentComponent;
import React, { useEffect, useState, useRef } from 'react';
import Product from './Product';
import Popular from './Popular';
import DealsOfTheDay from './DealsOfTheDay.jsx';
import Recommended from './Recommended.jsx';
import Slider from "react-slick";
import axios from 'axios';
import { useWishlist } from "../../contexts/WishlistContext";

function ParentComponent({
  refRestCart,
  uid,
  advertisements,
  loadingAds,
  adError,
  adSettings,
  selectedBrands = []
}) {
  const [categoriesWithCounts, setCategoriesWithCounts] = useState([]);
  const { products, setProducts } = useWishlist();
  const [loading, setLoading] = useState(false);
  const [totalItems, setTotalItems] = useState(0);
  const [brands, setBrands] = useState([]);
  
  const isBrandChangeReset = useRef(false);

  // Fetch brands
  useEffect(() => {
    const fetchBrands = async () => {
      try {
        const response = await axios.get("https://backend.frozenwala.com/api/item-brands/");
        let brandList = response.data;
        if (brandList.length > 0 && typeof brandList[0] === "object") {
          brandList = brandList.map((item) => item.name || item.brand_name || item.title);
        }
        brandList.sort((a, b) => a.localeCompare(b));
        setBrands(brandList);
      } catch (error) {
        console.error("Error fetching brands:", error);
      }
    };
    fetchBrands();
  }, []);

  const buildBrandParams = () =>
    selectedBrands && selectedBrands.length > 0
      ? `brand=${selectedBrands.map(b => encodeURIComponent(b)).join(',')}`
      : '';

  const getCategoriesWithCounts = async () => {
    try {
      const brandParams = buildBrandParams();
      let url = `https://backend.frozenwala.com/api/auth/categories/`;
      if (brandParams) url += `?${brandParams}`;
      const response = await axios.get(url);
      setCategoriesWithCounts(response.data);
      return response.data;
    } catch (error) {
      console.error("Error fetching categories with counts:", error);
      return [];
    }
  };

  const getProducts = async (categoryId) => {
    try {
      setLoading(true);
      const brandParams = buildBrandParams();
      let url;
      if (!categoryId || categoryId === 'all') {
        url = `https://backend.frozenwala.com/api/auth/product-all/`;
      } else {
        url = `https://backend.frozenwala.com/api/auth/category/product-all/?category_id=${categoryId}`;
      }
      if (brandParams) url += `${url.includes('?') ? '&' : '?'}${brandParams}`;
      const response = await axios.get(url);
      const data = response.data;
      const productList = data?.products ?? (Array.isArray(data) ? data : []);
      setProducts(productList);
      if (!categoryId || categoryId === 'all') setTotalItems(data?.total_items ?? productList.length);
      
      // ✅ After fetching products, fetch category counts for ALL categories with brand filter
      await getCategoriesWithCounts();
      
    } catch (error) {
      console.error("Error fetching products:", error);
      setProducts([]);
    } finally {
      setLoading(false);
    }
  };

  const getAllProducts = async () => {
    try {
      setLoading(true);
      const brandParams = buildBrandParams();
      let url = `https://backend.frozenwala.com/api/auth/product-all/`;
      if (brandParams) url += `?${brandParams}`;
      const response = await axios.get(url);
      const data = response.data;
      const productList = data?.products ?? (Array.isArray(data) ? data : []);
      setProducts(productList);
      setTotalItems(data?.total_items ?? productList.length);
      await updateCategoryCountsFromProducts(productList);
    } catch (error) {
      console.error("Error fetching all products:", error);
      setProducts([]);
      setTotalItems(0);
    } finally {
      setLoading(false);
    }
  };

  const updateCategoryCountsFromProducts = async (productList) => {
    try {
      const categoriesResponse = await axios.get(`https://backend.frozenwala.com/api/auth/categories/`);
      const allCategories = categoriesResponse.data;
      const categoryCountMap = new Map();
      productList.forEach(product => {
        const catId = product.category_id || product.category;
        if (catId) categoryCountMap.set(catId, (categoryCountMap.get(catId) || 0) + 1);
      });
      const updatedCategories = allCategories.map(category => ({
        ...category,
        total_items: categoryCountMap.get(category.id) || 0
      }));
      setCategoriesWithCounts(updatedCategories);
    } catch (error) {
      console.error("Error updating category counts:", error);
      await getCategoriesWithCounts();
    }
  };

  useEffect(() => {
    isBrandChangeReset.current = true;
    getAllProducts();
    setTimeout(() => { isBrandChangeReset.current = false; }, 100);
  }, [selectedBrands]);

  const handleCategoryChange = (categoryId) => {
    if (isBrandChangeReset.current) return;
    if (categoryId === 'all') getAllProducts();
    else getProducts(categoryId);
  };

  return (
    <div>
      {loading && <div className="loading-overlay"></div>}

      {/* 2. Side-by-Side Area */}
      <div 
        style={{ 
          margin: "0 auto", 
          maxWidth: "1280px", 
          paddingLeft: "15px", 
          paddingRight: "15px" 
        }} 
        className="mb-5"
      >
        <div className="row g-4 justify-content-center align-items-stretch">
          <div className="col-12 col-md-6 d-flex flex-column">
            <DealsOfTheDay
              refreshCart={refRestCart}
              uid={uid}
              selectedBrands={selectedBrands}
            />
          </div>
          <div className="col-12 col-md-6 d-flex flex-column">
            <Popular
              refreshCart={refRestCart}
              uid={uid}
              selectedBrands={selectedBrands}
            />
          </div>
        </div>
      </div>

      {/* Advertisements Slider Section */}
      {advertisements.length > 0 && (
        <div 
          style={{ 
            margin: "0 auto", 
            maxWidth: "1280px", 
            paddingLeft: "15px", 
            paddingRight: "15px" 
          }} 
          className="my-3 py-1"
        >
          <div className="row justify-content-center g-0">
            <div className="col-12" style={{ width: "100%" }}>
              <div className="advertisement-slider-container" style={{ width: "100%" }}>
                <style>{`
                  .advertisement-slider-container .slick-slide > div {
                    display: flex !important;
                    justify-content: center !important;
                  }
                  @media (max-width: 575.98px) {
                    .ad-responsive-img {
                      height: clamp(140px, 25vh, 220px) !important;
                    }
                  }
                `}</style>
                <Slider {...adSettings}>
                  {advertisements.map((ad) => (
                    <div key={ad.id} className="px-0" style={{ width: "100%" }}>
                      <div className="ad-slide" style={{ width: "100%" }}>
                        <img
                          src={ad.image}
                          alt={ad.title || "Advertisement"}
                          className="img-fluid rounded ad-responsive-img"
                          style={{
                            height: "300px",
                            objectFit: "cover",
                            width: "100%",
                            borderRadius: "10px",
                            boxShadow: "0 4px 12px rgba(0,0,0,0.1)"
                          }}
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = "/img/gallery/default-ad.jpg";
                          }}
                        />
                      </div>
                    </div>
                  ))}
                </Slider>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* 3. Main Product Catalog Grid Component */}
      <Product
        refreshCart={refRestCart}
        getProducts={handleCategoryChange}
        getAllProducts={getAllProducts}
        products={products}
        categoriesWithCounts={categoriesWithCounts}
        selectedBrands={selectedBrands}
        loading={loading}
        totalItems={totalItems}
        brands={brands}
      />

      <div className="mb-4">
        <Recommended
          refreshCart={refRestCart}
          uid={uid}
          selectedBrands={selectedBrands}
        />
      </div>
    </div>
  );
}

export default ParentComponent;